import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, finalize, switchMap, throwError } from 'rxjs';

export const refreshTokenInterceptor: HttpInterceptorFn = (req, next) => {
  let isRefreshing = false;

  return next(req);
  // return next(req).pipe(
  //   catchError((err) => {
  //     if (err.status === 401 && !isRefreshing) {
  //       isRefreshing = true;

  // WITH CREDENTIALS is applicable for logout endpoint too

  //       return this.http.post('/auth/refresh', {}, { withCredentials: true }).pipe(
  //         switchMap((res: any) => {
  //           this.authState.setToken(res.accessToken);
  //           isRefreshing = false;

  //           const retryReq = req.clone({
  //             setHeaders: { Authorization: `Bearer ${res.accessToken}` },
  //           });

  //           return next(retryReq);
  //         }),
  //         finalize(() => (isRefreshing = false))
  //       );
  //     }

  //     return throwError(() => err);
  //   })
  // );
};
